import { forwardRef } from 'react'

import classNames from 'classnames'

import styles from './index.module.css'

interface Props {
  className?: string
  [props: string]: any
}

export type Ref = HTMLInputElement

const Input = forwardRef<Ref, Props>(function Input(
  { className, ...props },
  ref
) {
  return (
    <input
      ref={ref}
      {...props}
      className={classNames(styles.input, className)}
    />
  )
})

export default Input
